import { createFileRoute } from '@tanstack/react-router';

import { Feedback } from '@/modules/ProjectFeedback';

export const Route = createFileRoute('/feedback/$token/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { token } = Route.useParams();

  return <Feedback token={token} />;
}
